import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-33a50ae0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "drag-handle" };
const _hoisted_2 = { class: "rule-name" };
const _hoisted_3 = { class: "rule-info" };
import { ref } from 'vue';
import DragHandleIcon from '@apparatix/icons/DragHandleIcon.vue';
import InfoIcon from '@apparatix/icons/InfoIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'YieldCodeRule',
    props: {
        name: {},
        itemKey: {},
        description: {}
    },
    setup(__props) {
        const props = __props;
        const tooltipText = ref(props.description ?? 'No description available');
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", {
                key: props.itemKey,
                class: "yield-code-rule"
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(DragHandleIcon)
                ]),
                _createElementVNode("div", _hoisted_2, _toDisplayString(props.name), 1),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(InfoIcon)
                ])), [
                    [_directive_tooltip, `${tooltipText.value}`]
                ])
            ]));
        };
    }
});
